import { Link } from "react-router-dom";

// ─── NAVBAR ───────────────────────────────────────────────────────────────
const Navbar = () => (
  <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-[#e8e4de]">
    <div className="max-w-7xl mx-auto px-[18px] md:px-12 lg:px-20 h-[76px] md:h-[120px] flex items-center justify-between">
      <Link to="/" className="flex items-center flex-shrink-0 min-w-0">
        <img
          src="/logo.png"
          alt="Del Valle Landscaping"
          className="h-[50px] md:h-[104px] w-auto object-contain block"
          style={{ maxWidth: "260px" }}
        />
      </Link>
      <nav className="hidden md:flex items-center gap-10">
        <Link
          to="/"
          className="text-[10px] tracking-[0.22em] uppercase text-[#6b6560] hover:text-[#1A1A1A] transition-colors duration-200"
        >
          Home
        </Link>
        <a
          href="/#services"
          className="text-[10px] tracking-[0.22em] uppercase text-[#6b6560] hover:text-[#1A1A1A] transition-colors duration-200"
        >
          Services
        </a>
        <a
          href="/#about"
          className="text-[10px] tracking-[0.22em] uppercase text-[#6b6560] hover:text-[#1A1A1A] transition-colors duration-200"
        >
          About
        </a>
        <a
          href="/#contact"
          className="text-[10px] tracking-[0.22em] uppercase text-[#6b6560] hover:text-[#1A1A1A] transition-colors duration-200"
        >
          Contact
        </a>
      </nav>
      <a
        href="tel:7073276586"
        className="hidden md:inline-flex bg-[#2F3E2F] text-white text-[9px] tracking-[0.18em] uppercase px-5 py-2.5 hover:bg-[#253225] transition-colors duration-200"
      >
        Call / Text 707-327-6586
      </a>
    </div>
  </header>
);

// ─── FOOTER ───────────────────────────────────────────────────────────────
const Footer = () => (
  <footer className="py-8 md:py-10 bg-white border-t border-[#e8e4de]">
    <div className="max-w-7xl mx-auto px-[24px] md:px-12 lg:px-20 flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left">
      <div className="flex items-center gap-3">
        <img
          src="/logo.png"
          alt="Del Valle Landscaping"
          className="h-8 md:h-9 w-auto object-contain"
        />
      </div>
      <p className="text-[10px] text-[#B8B2A6] tracking-widest">
        © {new Date().getFullYear()} Del Valle Landscaping · Sonoma County, CA · Lic. #07646
      </p>
      <a
        href="tel:7073276586"
        className="text-[11px] md:text-[10px] text-[#6b6560] tracking-widest hover:text-[#1A1A1A] transition-colors"
      >
        707-327-6586
      </a>
    </div>
  </footer>
);

// ─── FENCES & DECK CONSTRUCTION PAGE ─────────────────────────────────────
export default function FencesDeckConstruction() {
  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <Navbar />

      {/* ── HERO ─────────────────────────────────────────────────────── */}
      {/* Responsive object-position: desktop shows upper portion of portrait image; mobile centers structure */}
      <style>{`
        .hero-img {
          object-position: center 28%;
        }
        @media (max-width: 767px) {
          .hero-img {
            object-position: 52% 22%;
          }
        }
      `}</style>
      <section className="relative pt-[76px] md:pt-[120px] min-h-[80vh] flex items-end overflow-hidden">
        {/* Hero background — wooden pergola construction project */}
        <div className="absolute inset-0">
          <img
            src="/fd-hero-pergola.jpg"
            alt="Wooden pergola construction — Del Valle"
            className="hero-img absolute inset-0 w-full h-full object-cover"
          />
        </div>
        {/* Dark olive overlay */}
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(to top, rgba(20,28,20,0.88) 0%, rgba(47,62,47,0.55) 45%, rgba(47,62,47,0.45) 100%)",
          }}
        />
        {/* Content */}
        <div className="relative z-10 w-full pb-20 pt-24">
          <div className="max-w-7xl mx-auto px-5 md:px-12 lg:px-20">
            <p className="text-[9px] sm:text-[10px] tracking-[0.32em] uppercase text-white/60 mb-5 font-light">
              Structures · Del Valle Landscaping
            </p>
            <h1 className="font-serif text-[38px] sm:text-5xl md:text-6xl lg:text-[72px] font-medium leading-[1.08] text-white mb-6 tracking-[-0.01em] max-w-3xl">
              Fences &amp;{" "}
              <em className="italic font-normal">Deck Construction</em>
            </h1>
            <p className="text-[15px] md:text-base text-white/70 leading-[1.9] max-w-md mb-10 font-light">
              Custom fences, decks, pergolas, and outdoor structures built with
              precision, durability, and clean craftsmanship.
            </p>
            <a
              href="tel:7073276586"
              className="inline-flex bg-[#2F3E2F] text-white text-[10px] tracking-[0.22em] uppercase px-9 py-4 hover:bg-[#253225] transition-colors duration-300"
            >
              Call / Text 707-327-6586
            </a>
          </div>
        </div>
      </section>

      {/* ── PROJECT GALLERY ──────────────────────────────────────────── */}
      <section className="py-10 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-5 md:px-12 lg:px-20">
          <p className="text-[9px] md:text-[10px] tracking-[0.32em] uppercase text-[#B8B2A6] mb-6 font-light">
            Our Work
          </p>

          {/* Large main gallery image */}
          <div
            className="w-full mb-3 overflow-hidden group"
            style={{ height: "clamp(260px, 52vw, 600px)" }}
          >
            <img
              src="/fd-gallery-main.jpg"
              alt="Pergola and wooden structure — Del Valle"
              className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.02]"
              style={{ objectPosition: "center center" }}
            />
          </div>

          {/* 2 supporting images */}
          <div className="grid grid-cols-2 gap-3">
            <div
              className="overflow-hidden group"
              style={{ height: "clamp(120px, 22vw, 280px)" }}
            >
              <img
                src="/fd-gallery-1.jpg"
                alt="Fence installation — Sonoma County"
                className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
                style={{ objectPosition: "center center" }}
              />
            </div>
            <div
              className="overflow-hidden group"
              style={{ height: "clamp(120px, 22vw, 280px)" }}
            >
              <img
                src="/fd-gallery-2.png"
                alt="Pergola under construction — Del Valle"
                className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
                style={{ objectPosition: "center center" }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* ── ABOUT THIS SERVICE ───────────────────────────────────────── */}
      <section className="py-8 md:py-16 bg-[#F4F1EA]">
        <div className="max-w-7xl mx-auto px-5 md:px-12 lg:px-20">
          <div className="max-w-2xl">
            <p className="text-[9px] md:text-[10px] tracking-[0.32em] uppercase text-[#B8B2A6] mb-5 font-light">
              About This Service
            </p>
            <h2 className="font-serif text-[30px] md:text-4xl lg:text-5xl font-medium text-[#1A1A1A] mb-8 tracking-[-0.01em] leading-[1.1]">
              Outdoor Structures Built with{" "}
              <em className="italic font-normal">Strength and Style</em>
            </h2>
            <div className="w-10 h-px bg-[#B8B2A6] mb-8" />
            <p className="text-base text-[#6b6560] leading-[1.9] font-light">
              At Del Valle Landscaping, every fence and deck we build starts with a solid
              foundation. Posts are set deep, boards are fastened with
              precision, and every surface is sealed and finished for lasting
              performance in Sonoma County's climate. From cedar privacy fences
              to multi-level composite decks and pergola structures — we design
              and build outdoor spaces that enhance your property for decades to
              come.
            </p>
          </div>
        </div>
      </section>

      {/* ── FEATURES / WHAT WE DO ────────────────────────────────────── */}
      <section className="py-8 md:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-5 md:px-12 lg:px-20">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 md:gap-24">
            <div>
              <p className="text-[9px] md:text-[10px] tracking-[0.32em] uppercase text-[#B8B2A6] mb-5 font-light">
                What We Do
              </p>
              <h2 className="font-serif text-[28px] md:text-4xl font-medium text-[#1A1A1A] mb-10 tracking-[-0.01em] leading-[1.1]">
                Our Capabilities
              </h2>
              <ul className="space-y-5">
                {[
                  "Wood & cedar privacy fences",
                  "Redwood & pressure-treated fencing",
                  "Metal & ornamental iron fences",
                  "Ranch & split-rail fencing",
                  "Custom deck construction",
                  "Multi-level deck design & build",
                  "Composite & pressure-treated decking",
                  "Pergolas & covered outdoor structures",
                ].map((item, i) => (
                  <li
                    key={i}
                    className="flex items-start gap-4 text-sm text-[#6b6560] font-light leading-[1.8]"
                  >
                    <span className="mt-[9px] w-4 h-px bg-[#B8B2A6] flex-shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            {/* ── PROCESS ─────────────────────────────────────────────── */}
            <div>
              <p className="text-[9px] md:text-[10px] tracking-[0.32em] uppercase text-[#B8B2A6] mb-5 font-light">
                How We Work
              </p>
              <h2 className="font-serif text-[28px] md:text-4xl font-medium text-[#1A1A1A] mb-10 tracking-[-0.01em] leading-[1.1]">
                Our Process
              </h2>
              <div className="relative">
                <div className="absolute left-[23px] top-0 bottom-0 w-px bg-[#e4e0da]" />
                <div className="flex flex-col">
                  {[
                    {
                      num: "01",
                      title: "Consultation",
                      desc: "We walk your property, review layout options, and discuss materials best suited for your use case.",
                    },
                    {
                      num: "02",
                      title: "Planning",
                      desc: "We produce a clear plan including post placement, material specs, permit requirements, and timeline.",
                    },
                    {
                      num: "03",
                      title: "Construction",
                      desc: "Foundation setting, structural framing, board installation, and all finish work — executed with precision.",
                    },
                    {
                      num: "04",
                      title: "Final Walkthrough",
                      desc: "We inspect every post, board, and connection with you to confirm structural soundness and finish quality.",
                    },
                  ].map((step, i) => (
                    <div
                      key={i}
                      className="relative flex gap-8 pb-10 last:pb-0"
                    >
                      <div className="relative z-10 flex-shrink-0 w-12 h-12 bg-white border border-[#e4e0da] flex items-center justify-center">
                        <span className="font-serif text-xs font-medium text-[#B8B2A6]">
                          {step.num}
                        </span>
                      </div>
                      <div className="pt-3">
                        <h3 className="text-[10px] font-medium tracking-[0.22em] uppercase text-[#1A1A1A] mb-2">
                          {step.title}
                        </h3>
                        <p className="text-sm text-[#6b6560] leading-[1.8] font-light">
                          {step.desc}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── CTA SECTION ─────────────────────────────────────────────── */}
      <section className="py-12 md:py-20 bg-[#1A1A1A]">
        <div className="max-w-7xl mx-auto px-5 md:px-12 lg:px-20 text-center">
          <p className="text-[9px] md:text-[10px] tracking-[0.32em] uppercase text-[#B8B2A6] mb-6 font-light">
            Start Your Project
          </p>
          <h2 className="font-serif text-[34px] md:text-5xl lg:text-6xl font-medium text-white mb-8 tracking-[-0.01em] leading-[1.1]">
            Ready to Start Your Project?
          </h2>
          <p className="text-base text-[#9a958f] font-light leading-[1.8] mb-12 max-w-md mx-auto">
            Contact Lucio directly for a free on-site estimate. We respond the
            same day.
          </p>
          <a
            href="tel:7073276586"
            className="inline-flex bg-white text-[#1A1A1A] text-[10px] tracking-[0.22em] uppercase px-10 py-4 hover:bg-[#f0ece4] transition-colors duration-300"
          >
            Call / Text 707-327-6586
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
